import { render, staticRenderFns } from "./FileLoaderModal.vue?vue&type=template&id=297ea9ef&lang=pug"
import script from "./FileLoaderModal.vue?vue&type=script&lang=js"
export * from "./FileLoaderModal.vue?vue&type=script&lang=js"
import style0 from "./FileLoaderModal.vue?vue&type=style&index=0&id=297ea9ef&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports